// extracted by mini-css-extract-plugin
export default {"tableStyles":"TotalSummaryMeterTable_tableStyles__mKA3z","summaryCellStyle":"TotalSummaryMeterTable_summaryCellStyle__rCyaR"};